import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SKIP_SESSION_REFRESH } from '../http/skip-session-refresh.token';
import { SessionRefreshService } from '../services/session-refresh.service';

function isApiRequest(url: string): boolean {
  const normalizedUrl = url.toLowerCase();
  const api = (environment.apiUrl || '').toLowerCase();
  const security = (environment.securityApiUrl || '').toLowerCase();
  const bot = (environment.botApiUrl || '').toLowerCase();
  return (
    (api.length > 0 && normalizedUrl.startsWith(api)) ||
    (security.length > 0 && normalizedUrl.startsWith(security)) ||
    (bot.length > 0 && normalizedUrl.startsWith(bot))
  );
}

function shouldIgnoreSessionRefresh(url: string): boolean {
  const normalizedUrl = url.toLowerCase();
  return normalizedUrl.includes('/auth/refresh')
    || normalizedUrl.includes('/auth/twitch/callback')
    || normalizedUrl.includes('/auth/twitch/login')
    || normalizedUrl.includes('/auth/logout');
}

export const sessionRefreshInterceptor: HttpInterceptorFn = (req, next) => {
  const sessionRefresh = inject(SessionRefreshService);

  if (!isApiRequest(req.url) || req.context.get(SKIP_SESSION_REFRESH) || shouldIgnoreSessionRefresh(req.url)) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse) || error.status !== 401) {
        return throwError(() => error);
      }

      return sessionRefresh.refreshSession().pipe(
        switchMap((refreshed) => {
          if (!refreshed) {
            return throwError(() => error);
          }

          return next(req.clone({
            context: req.context.set(SKIP_SESSION_REFRESH, true)
          }));
        }),
        catchError(() => throwError(() => error))
      );
    })
  );
};

